import React from 'react';

const ExampleCarouselImage = ({ src, alt = 'Featured project image' }) => {
  return (
    <div className="carousel-image-container">
      <img
        className="carousel-image"
        src={src}
        alt={alt}
        loading="lazy"
      />
    </div>
  );
};

export default ExampleCarouselImage;
